"use strict";
/**
 * @author Piotr Witek <piotrek.witek@gmail.com> (http://piotrwitek.github.io)
 * @copyright Copyright (c) 2016 Piotr Witek
 * @license MIT
 */
Object.defineProperty(exports, "__esModule", { value: true });
var aliases_and_guards_1 = require("./aliases-and-guards");
exports.isFalsy = aliases_and_guards_1.isFalsy;
exports.isNullish = aliases_and_guards_1.isNullish;
exports.isPrimitive = aliases_and_guards_1.isPrimitive;
// deprecated
var functional_helpers_1 = require("./functional-helpers");
exports.getReturnOfExpression = functional_helpers_1.getReturnOfExpression;
//# sourceMappingURL=index.js.map